import { render, staticRenderFns } from "./waitlist-thankyou.vue?vue&type=template&id=3ffaf21f&"
import script from "./waitlist-thankyou.vue?vue&type=script&lang=js&"
export * from "./waitlist-thankyou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports